export function canonicalGameToDisplayLabel(value: unknown): string {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized === "pokemon" || normalized === "pokémon") return "Pokémon";
  if (normalized === "mtg" || normalized === "magic" || normalized === "magic: the gathering") {
    return "Magic: The Gathering";
  }
  if (normalized === "yugioh" || normalized === "yu-gi-oh" || normalized === "yu-gi-oh!") {
    return "Yu-Gi-Oh!";
  }
  if (normalized === "one piece" || normalized === "one-piece") {
    return "One Piece";
  }
  return String(value || "");
}
